import { Box, FormControlLabel, Radio } from '@mui/material'

export type PermanentAccessSectionProps = {
  disabled: boolean
  constantValue: string
  label: string
}

export function PermanentAccessSection({
  disabled,
  constantValue,
  label,
}: PermanentAccessSectionProps) {
  return (
    <Box sx={{ width: '100%', mb: 0.5 }}>
      <FormControlLabel
        value={constantValue}
        control={<Radio disabled={disabled} />}
        label={label}
      />
    </Box>
  )
}
